import { useCallback, useRef, useState } from 'react';

import { Cropper, ReactCropperElement } from 'react-cropper';
import { FieldValues, UseFormSetValue } from 'react-hook-form';

import { Box, Button, Flex } from '@brand/components';
import helpers from 'helpers';
import { v4 as uuid } from 'uuid';

import 'cropperjs/dist/cropper.css';

interface IUploadFileFieldCropperProps {
  handleRemoveImage: () => void;
  imageUrl: string;
  name: string;
  setFieldValue: UseFormSetValue<FieldValues>;
}

const UploadFileFieldCropper = ({
  handleRemoveImage,
  imageUrl,
  name,
  setFieldValue,
}: IUploadFileFieldCropperProps): JSX.Element => {
  const [imageSrc, setImageSrc] = useState<string>(imageUrl);

  const previewImageRef = useRef<ReactCropperElement>(
    {} as ReactCropperElement,
  );

  const handleCropImage = useCallback(async () => {
    const { cropper } = previewImageRef.current;

    if (cropper) {
      const imgFile = cropper.getCroppedCanvas().toDataURL();
      setImageSrc(imgFile);

      const blobImage = await helpers.dataUrlToFile({
        dataUrl: imageSrc,
        fileName: `${uuid().slice(0, 4)}.png`,
      });
      setFieldValue(name, blobImage);
    }
  }, [setFieldValue, name, imageSrc]);

  return (
    <Box>
      <Box
        alignItems="center"
        display="flex"
        justifyContent="center"
        maxHeight="400px"
        mx="auto"
        my="1rem"
        width="300px"
      >
        <Cropper
          autoCropArea={1}
          background
          draggable={false}
          guides={false}
          ref={previewImageRef}
          src={imageSrc}
          style={{ height: 400, width: '100%' }}
          toggleDragModeOnDblclick={false}
          viewMode={2}
        />
      </Box>

      <Flex columnGap={2} justify="center" mt={4}>
        <Button
          fontSize="14px"
          onClick={handleRemoveImage}
          padding="8px 16px"
          size="sm"
          type="button"
          variant="gray"
        >
          Remove
        </Button>
        <Button
          fontSize="14px"
          onClick={handleCropImage}
          padding="8px 16px"
          size="sm"
          type="button"
          variant="solidBlue"
        >
          Crop image
        </Button>
      </Flex>
    </Box>
  );
};

export default UploadFileFieldCropper;
